export default "__VITE_ASSET__CWgayCJC__";